import styled from "styled-components";
import { MarginProps, space, typography } from "styled-system";

import colors, { ColorType } from "theme/colors.module.scss";

type TextVariant =
  | "h1"
  | "h2"
  | "p"
  | "pBold"
  | "pSM"
  | "pSMBold"
  | "label"
  | "labelUppercase"
  | "labelBold"
  | "labelSM"
  | "menuItem"
  | "inherit";

const textVariants: { [key in TextVariant]: string } = {
  h1: `
    font-size: 32px;
    line-height: 43px;
    font-weight: 800;
  `,
  h2: `
    font-size: 24px;
    line-height: 32px;
    font-weight: 800;
  `,
  p: `
    font-size: 16px;
    line-height: 22px;
    font-weight: 400;
  `,
  pBold: `
    font-size: 16px;
    line-height: 20px;
    font-weight: 700;
  `,
  pSM: `
    font-size: 14px;
    line-height: 20px;
    font-weight: 400;
  `,
  pSMBold: `
    font-size: 14px;
    line-height: 20px;
    font-weight: 700;
  `,
  label: `
    font-size: 12px;
    line-height: 18px;
    font-weight: 400;
  `,
  labelSM: `
    font-size: 10px;
    line-height: 16px;
    font-weight: 400;
  `,
  labelUppercase: `
    font-size: 12px;
    line-height: 18px;
    font-weight: 700;
    text-transform: uppercase;
  `,
  labelBold: `
    font-size: 12px;
    line-height: 18px;
    font-weight: 700;
  `,
  menuItem: `
    font-size: 10px;
    line-height: 18px;
    font-weight: 400;
  `,
  inherit: "",
};

export type TextProps = {
  $textColor?: ColorType;
  $textVariant?: TextVariant;
  $textWeight?: 100 | 200 | 300 | 400 | 500 | 600 | 700 | 800 | 900;
  strikethrough?: boolean;
  textAlign?: string;
} & MarginProps;

export const Text = styled.p<TextProps>`
  white-space: pre-line;
  word-break: break-word;  
  ${space}
  ${typography}
  ${({ $textColor }) => $textColor && `color: ${colors[$textColor]};`}
  ${({ $textVariant = "p" }) => textVariants[$textVariant]}
  ${({ $textWeight }) => $textWeight && `font-weight: ${$textWeight};`}
  ${({ strikethrough }) => strikethrough && `text-decoration: line-through;`}
`;
